import React, { useEffect } from 'react';
import { useCart } from '../context/CartContext';
import { Offcanvas } from 'react-bootstrap';
import { formatBRL } from '../utils/currency';
import '../styles/Cart.css';
import { trackBeginCheckout, trackViewCart } from '../utils/analytics';
import { buildWhatsAppMessage, buildWhatsAppLink } from '../utils/whatsapp';
import { WHATSAPP_NUMBER } from '../config';

const Cart: React.FC = () => {
  const { items, setQty, removeItem, subtotalCents, clear, isCartOpen, closeCart } = useCart();

  useEffect(() => {
    if (isCartOpen && items.length > 0) {
      try { trackViewCart({ value: subtotalCents / 100, items_count: items.length }); } catch(_) {}
    }
  }, [isCartOpen, items, subtotalCents]);

  const handleCheckout = () => {
    try { trackBeginCheckout({ value: subtotalCents / 100, items_count: items.length }); } catch(_) {}
    const message = buildWhatsAppMessage(items, subtotalCents, {});
    const url = buildWhatsAppLink(WHATSAPP_NUMBER, message);
    window.open(url, '_blank');
  };

  return (
    <Offcanvas show={isCartOpen} onHide={closeCart} placement="end" className="cart-offcanvas">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Carrinho</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        {items.length === 0 ? (
          <p className="cart-empty">Seu carrinho está vazio.</p>
        ) : (
          <div className="cart-wrapper">
            <ul className="cart-list">
              {items.map((item) => (
                <li key={item.skuId} className="cart-item">
                  {item.image && (
                    <img
                      src={item.image}
                      alt={item.productName}
                      className="cart-item-image"
                      loading="lazy"
                      decoding="async"
                      width={96}
                      height={96}
                    />
                  )}
                  <div className="cart-item-info">
                    <div className="cart-item-title">
                      <strong>{item.productName}</strong>
                      {item.variantName ? <span className="variant"> — {item.variantName}</span> : null}
                    </div>
                    <div className="cart-item-controls">
                      <span className="price">{formatBRL(item.unitPriceCents)}</span>
                      <div className="qty-controls">
                        <button onClick={() => setQty(item.skuId, Math.max(0, item.qty - 1))} aria-label="Diminuir">
                          −
                        </button>
                        <input
                          type="number"
                          min={0}
                          value={item.qty}
                          onChange={(e) => setQty(item.skuId, Math.max(0, parseInt(e.target.value || '0', 10)))}
                        />
                        <button onClick={() => setQty(item.skuId, item.qty + 1)} aria-label="Aumentar">
                          +
                        </button>
                      </div>
                      <button className="remove" onClick={() => removeItem(item.skuId)}>
                        Remover
                      </button>
                    </div>
                  </div>
                  {item.includes?.length ? (
                    <ul className="cart-item-includes">
                      {item.includes.map((included) => (
                        <li key={included}>{included}</li>
                      ))}
                    </ul>
                  ) : null}
                </li>
              ))}
            </ul>
          </div>
        )}
      </Offcanvas.Body>
      {items.length > 0 && (
        <div className="cart-footer">
          <div className="cart-summary">
            <div className="row">
              <span>Subtotal</span>
              <strong>{formatBRL(subtotalCents)}</strong>
            </div>
            <p className="hint">Frete e formas de pagamento combinados no WhatsApp.</p>
            <div className="actions">
              <button
                className="btn btn-success"
                onClick={handleCheckout}
              >
                Finalizar no WhatsApp
              </button>
              <button className="btn btn-outline-light" onClick={clear}>Esvaziar</button>
            </div>
          </div>
        </div>
      )}
    </Offcanvas>
  );
};

export default Cart;
